import api from '../api';

export function listElements(slideId) {
    return api.get(`/elements?slide_id=${slideId}`).then(response => response.data);
}

export function fetchElement(elementId) {
    return api.get(`/elements/${elementId}`).then(response => response.data);
}

export function createElement(slideId, type, data) {
    return api.post(`/elements`, {
        'slide_id': slideId,
        'type': type,
        'data': data
    });
}

export function addTextElement(storyId, slideId, elementId) {
    return api.post(`/elements`, {
        'element_id': elementId,
        'slide_id': slideId,
        'story_id': storyId,
        'type': 'text'
    });
}

export function addImageElement(storyId, slideId, elementId) {
    return api.post(`/elements`, {
        'element_id': elementId,
        'slide_id': slideId,
        'story_id': storyId,
        'type': 'image'
    });
}

export function updateElement(elementId, x, y, w, h, data) {
    return api.put(`/elements/${elementId}`, {
        'x': x,
        'y': y,
        'width': w,
        'height': h,
        'data': data
    });
}

export function removeElement(elementId) {
    return api.delete(`/elements/${elementId}`);
}

export function bringForward(elementId) {
    return api.post(`/elements/${elementId}/bring_forward`);
}

export function sendBackward(elementId) {
    return api.post(`/elements/${elementId}/send_backward`);
}

export function bringToFront(elementId) {
    return api.post(`/elements/${elementId}/bring_to_front`);
}

export function sendToBack(elementId) {
    return api.post(`/elements/${elementId}/send_to_back`);
}
